import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d76013b")

_pushScopeId("data-v-4d76013b")
const _hoisted_1 = { class: "avatar-image-container" }
const _hoisted_2 = {
  key: 0,
  class: "closed"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_card = _resolveComponent("ion-card")

  return (_openBlock(), _createBlock(_component_ion_card, {
    class: $props.establishment.status ? 'open' : 'closedCard',
    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goEstablishment($props.establishment.id)))
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_ion_img, {
          class: "avatar",
          src: `https://storage.googleapis.com/thelivery/img/clients/${$props.establishment.logo}`
        }, null, 8, ["src"]),
        (!$props.establishment.status)
          ? (_openBlock(), _createBlock("div", _hoisted_2, "Fechado"))
          : _createCommentVNode("", true)
      ]),
      _createVNode("p", null, _toDisplayString($props.establishment.name), 1)
    ]),
    _: 1
  }, 8, ["class"]))
})